<template>
  <div>

    <div class="web-only">
      <div style="height: calc(100vh - 120px);" class="row web-only">
        <div class="col-lg-4 my-auto">
          <!-- <img src="../../../assets/img/marathondynamics/MDIlogo.png" alt="Marathon Dynamics" class="pl-5" style="padding-right: 0px; max-width: 100%;" id="MDI"> -->
          <img src="../../../assets/img/marathondynamics/New MDI Logo Gary W.png" alt="Marathon Dynamics" class="pl-5" style="padding-right: 0px; max-width: 100%;" id="MDI">
        </div>
        <div class="col-lg-8 my-auto">
          <!-- <p style="text-align: left; color: var(--MDI); font-size: 38px; line-height: 1.2; margin-bottom: 25px; font-weight: 700;" class="pl-5">The mind leads the body.</p> -->
          <img src="../../../assets/img/marathondynamics/MindLeadsBodyPurple.png" alt="The Mind Leads the Body" class="px-5 mb-4" style="padding-right: 0px; max-width: 500px;" id="MDI">
          <div class="pl-5">
            <hr>
            <router-link v-if="!auth" to="/login" class="btn btn-mdi">SIGN IN</router-link>
            <router-link v-if="!auth" to="/marathondynamics/register" class="btn btn-mdi">SIGN UP</router-link>
            <!-- <hr> -->
          </div>
        </div>
      </div>
      <img src="../../../assets/img/marathondynamics/New Byline 2.png" alt="Run Faster, Have Fun, Meet Friends" height="90px" style="display: block; margin-left: auto; margin-right: auto;" id="byline">
    </div>


    <div class="mobile-only">
      <div class="pl-5 pr-4 mt-3" style="line-height: 1.1;">
        <!-- <p style="text-align: center; color: var(--MDI); font-size: 38px; line-height: 1.1; margin-bottom: 5px;">The mind leads the body.</p> -->
        <!-- <img src="../../../assets/img/marathondynamics/MindLeadsBodyPurple.png" alt="The Mind Leads the Body" class="pl-5" style="padding-right: 0px; max-width: 100%;" id="MDI"> -->
        <img src="../../../assets/img/marathondynamics/New MDI Logo Gary W.png" alt="Marathon Dynamics" class="px-5 mb-2" style="padding-right: 0px; max-width: 100%;" id="MDI">
        <div style="display: block; margin-left: auto; margin-right: auto;" class="mt-4">
          <router-link style="display: block; margin-left: auto; margin-right: auto; max-width: 180px;" v-if="!auth" to="/login" class="btn btn-mdi">SIGN IN</router-link>
          <router-link style="display: block; margin-left: auto; margin-right: auto; max-width: 180px;" v-if="!auth" to="/register" class="btn btn-mdi mt-1">SIGN UP</router-link>
        </div>


      </div>
      <div class="pl-5 pr-4" style="">
        <!-- <img src="../../../assets/img/marathondynamics/MDIlogo.png" alt="marathon dynamics" class="pt-5 mb-4" style="max-width: 100%;" id=""> -->
        <img src="../../../assets/img/marathondynamics/MindLeadsBodyPurple.png" alt="The Mind Leads the Body" class="px-2 mt-5 mb-4" style="max-width: 100%;" id="MDI">
        <img src="../../../assets/img/marathondynamics/New Byline 2.png" alt="Run Faster, Have Fun, Meet Friends" class="mt-5" style="max-width: 100%" id="byline">
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    computed: {
      funds() {
        return this.$store.getters.funds;
      },
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
    }
  }
</script>

<style>

  .cheetah img {
    /* max-height: 500px; */
    /* max-height: 100vh; */
    /* width: 100%; */
    text-align: right;
    /* display: block; */
    margin-left: auto;
    float: right;
    /* margin-right: auto; */
  }

</style>



// WEBPACK FOOTER //
// src/components/myrundash/marathondynamics/Home.vue